<template>
  <div>
    <div class="cud-title">{{ $t('Bill.ResourceOptimization.CUDRecommendationPage') }}</div>
    <!-- 筛选框 -->
    <div class="cudRecommendSearch">
      <Form
        ref="cudRecommendForm"
        :model="cudRecommendForm"
        :rules="ruleValidate"
      >
        <Row>
          <Col span="24">
            <Row
              style="
                width: 100%;
                background-color: #fff;
                height: 53px;
                padding-top: 7px;
              "
            >
              <Col span="24">
                <Row :gutter="10">
                  <!-- 公司 -->
                  <Col span="4" v-if="companyIdShow == 1">
                    <FormItem label="" prop="companyId">
                      <Select
                        v-model="cudRecommendForm.companyId"
                        filterable
                        :transfer="true"
                        @on-change="changeMonitorIndex()"
                        :placeholder="$t('KPI.pleaseSelectCompany')"
                      >
                        <Option
                          v-for="item in companyIdList"
                          :value="item.id"
                          :key="item.id"
                          >{{ item.companyName }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 账号 -->
                  <Col span="4">
                    <FormItem label="" prop="accountId">
                      <Select
                        v-model="cudRecommendForm.accountId"
                        filterable
                        :transfer="true"
                        :placeholder="$t('alarms.common.pleaseSelectAccount')"
                      >
                        <Option
                          v-for="item in accountIdList"
                          :value="item.id"
                          :key="item.id"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 机型 -->
                  <Col span="4">
                    <FormItem label="" prop="cudType">
                      <Select
                        v-model="cudRecommendForm.cudType"
                        filterable
                        :transfer="true"
                        @on-change="searchAvailableArea()"
                        :placeholder="$t('cudRecommendForm.cudType')"
                      >
                        <Option
                          v-for="item in cudTypeList"
                          :value="item.cudType"
                          :key="item.cudType"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 可用区 -->
                  <Col span="4">
                    <FormItem label="" prop="availableArea">
                      <Select
                        v-model="cudRecommendForm.availableArea"
                        filterable
                        :transfer="true"
                        :placeholder="$t('cudRecommendForm.availableArea')"
                      >
                        <Option
                          v-for="item in availableAreaList"
                          :value="item.name"
                          :key="item.name"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <!-- 资源类型 -->
                  <Col span="4">
                    <FormItem label="" prop="resourceType">
                      <Select
                        v-model="cudRecommendForm.resourceType"
                        filterable
                        :transfer="true"
                        :placeholder="$t('RAM.common.PleaseSelectResourceType')"
                      >
                        <Option
                          v-for="item in resourceTypeList"
                          :value="item.resourceType"
                          :key="item.resourceType"
                          >{{ item.name }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="4">
                    <Button
                      type="primary"
                      @click="searchAll('cudRecommendForm')"
                      >{{ $t("cudrecommendation.search") }}</Button
                    >
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>

    <!-- 已经购买CUD数 & 建议购买CUD数 & 本月未匹配CUD平均数量 & 下月推荐购买CUD后节省费用 -->
    <Row :gutter="10" style="margin-bottom: 10px">
      <Col span="6">
        <Card :padding="8">
          <Row>
            <Col class="title">{{ $t('Bill.ResourceOptimization.recommendedPurchaseCUDNumber') }}</Col>
          </Row>
          <Row>
            <Col span="24" style="text-align: center; font-size: 40px">{{
                numberOfRIRecommendedForPurchase
              }}</Col>
          </Row>
        </Card>
      </Col>
      <Col span="6">
        <Card :padding="8">
          <Row>
            <Col class="title">{{ $t('Bill.ResourceOptimization.purchasedCUDNumber') }}</Col>
          </Row>
          <Row>
            <Col span="24" style="text-align: center; font-size: 40px">{{
              numberOfRIPurchased
            }}</Col>
          </Row>
        </Card>
      </Col>
      <Col span="6">
        <Card :padding="8">
          <Row>
            <Col class="title">{{ $t('Bill.ResourceOptimization.noMatchCUD') }}</Col>
          </Row>
          <Row>
            <Col span="24" style="text-align: center; font-size: 40px">{{
              averageQuantityOfUnmatchedCuds
            }}</Col>
          </Row>
        </Card>
      </Col>
      <Col span="6">
        <Card :padding="8">
          <Row>
            <Col class="title">{{ $t('Bill.ResourceOptimization.nextMonthCUD') }}</Col>
          </Row>
          <Row>
            <Col span="24" style="text-align: center; font-size: 40px">{{
              costSavingsAfterCudPurchase
            }}</Col>
          </Row>
        </Card>
      </Col>
    </Row>

    <!-- 柱状图 -->
    <Row :gutter="10" style="margin-bottom: 10px">
      <Col span="24">
        <Card :padding="8">
          <Row>
            <Col>
              <Row>
                <Col span="18" class="title">{{ $t('Bill.ResourceOptimization.CUDUsage') }}</Col>
              </Row>
            </Col>
            <Col>
              <div id="cudUsage" style="width: 100%; height: 300px"></div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>

    <!-- CUD到期信息列表 -->
    <Row style="margin-bottom: 10px">
      <Col span="24">
        <Row>
          <Col class="title">CUD到期信息列表</Col>
        </Row>
        <Table
          :no-data-text="$t('common.noData')"
          :columns="columns"
          :data="tableDate"
          style="width: 100%"
          border
        ></Table>
      </Col>
    </Row>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
export default {
  name: "KPI",
  data() {
    return {
      cudRecommendForm: {
        companyId: "",
        accountId: "",
        cudType: "",
        availableArea: "",
        resourceType: "",
      },
      cudTypeList: [],
      accountIdList: [],
      companyIdList: [],
      availableAreaList: [], //筛选条件
      numberOfRIPurchased: "", //已经购买CUD数
      numberOfRIRecommendedForPurchase: "", //&建议购买CUD数
      averageQuantityOfUnmatchedCuds: "",
      costSavingsAfterCudPurchase: "",
      columns: [
        {
          title: this.$t("cudrecommendation.commitmentId"),
          key: "commitmentId",
        },
        {
          title: this.$t("cudrecommendation.name"),
          key: "name",
        },
        {
          title: this.$t("cudrecommendation.start"),
          key: "start",
        },
        {
          title: this.$t("cudrecommendation.end"),
          key: "end",
        },
        {
          title: this.$t("cudrecommendation.autoRenew"),
          key: "autoRenew",
        },
        {
          title: this.$t("cudrecommendation.typeName"),
          key: "typeName",
        },
        {
          title: this.$t("cudrecommendation.statusName"),
          key: "statusName",
        },
        {
          title: this.$t("cudrecommendation.planName"),
          key: "planName",
        },
      ],
      ruleValidate: {
        companyId: [
          {
            required: true,
            message: "请选择公司",
          },
        ],
        accountId: [
          {
            required: true,
            message: "请选择账号",
          },
        ],
        cudType: [
          {
            required: true,
            message: "请选择机型",
          },
        ],
        availableArea: [
          {
            required: true,
            message: "请选择可用区",
          },
        ],
        resourceType: [
          {
            required: true,
            message: "请选择资源类型",
          },
        ],
      },
      tableDate: [], //CUD到期信息列表
      resourceTypeList: [],
      chartCudUsage: "", //柱状图
      companyIdShow: getCookie(global.companyId),
    };
  },
  mounted() {
    this.init();
    // 自适应不同屏幕尺寸
    const self = this;
    window.addEventListener("resize", function () {
      self.chartCudUsage.resize();
    });
    //this.searchAll();
  },
  created() {
    this.$nextTick(function () {
      // 公司
      this.listRegisterInformation();
      // 机型
      this.queryInstanceTypeBox();
      //资源类型
      this.queryReosurceTypeBox();
    });
  },
  methods: {
    changeMonitorIndex: function () {
      // 账号
      this.queryGCPAccountBox();
    },
    searchAvailableArea: function () {
      // 可用区
      this.queryRegionBox();
    },
    /*********************查询************************/
    searchAll: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 已经购买CUD数
          this.queryBoughtNum();
          // 建议购买CUD数
          this.queryRecommendNum();
          // CUD到期信息列表
          this.queryCUDExpireList();
          //本月未匹配CUD平均数量
          this.queyrUnMaptchNum();
          //下月推荐购买CUD后节省费用
          this.queryCostSaving();
          //柱状图
          this.checkCudStatistics();
        }
      });
    },

    // 公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        this.companyIdList = res.data.companies;
      });
    },
    // 账号
    queryGCPAccountBox: function () {
      this.$api.cudRecommend
        .queryGCPAccountBox({
          companyId: this.cudRecommendForm.companyId,
        })
        .then((res) => {
          this.accountIdList = res.data;
        });
    },
    // 机型
    queryInstanceTypeBox: function () {
      this.$api.cudRecommend
        .queryInstanceTypeBox({
          companyId: this.cudRecommendForm.companyId,
          accountId: this.cudRecommendForm.accountId,
        })
        .then((res) => {
          this.cudTypeList = res.data;
        });
    },
    // 可用区
    queryRegionBox: function () {
      this.$api.cudRecommend
        .queryRegionBox({
          companyId: this.cudRecommendForm.companyId,
          accountId: this.cudRecommendForm.accountId,
          cudType: this.cudRecommendForm.cudType,
        })
        .then((res) => {
          this.availableAreaList = res.data;
        });
    },
    //资源类型
    queryReosurceTypeBox: function () {
      this.$api.cudRecommend.queryReosurceTypeBox().then((res) => {
        this.resourceTypeList = res.data;
      });
    },

    /*********************已经购买CUD数*********************/
    queryBoughtNum: function () {
      this.$api.cudRecommend
        .queryBoughtNum({
          accountId: this.cudRecommendForm.accountId,
          region: this.cudRecommendForm.availableArea,
          cudType: this.cudRecommendForm.cudType,
          resourceType: this.cudRecommendForm.resourceType,
        })
        .then((res) => {
          this.numberOfRIPurchased = res.data;
        });
    },
    /*********************建议购买CUD数*********************/
    queryRecommendNum: function () {
      this.$api.cudRecommend
        .queryRecommendNum({
          accountId: this.cudRecommendForm.accountId,
          region: this.cudRecommendForm.availableArea,
          cudType: this.cudRecommendForm.cudType,
          resourceType: this.cudRecommendForm.resourceType,
        })
        .then((res) => {
          this.numberOfRIRecommendedForPurchase = res.data;
        });
    },
    /*********************本月未匹配CUD平均数量*********************/
    queyrUnMaptchNum: function () {
      this.$api.cudRecommend
        .queyrUnMaptchNum({
          accountId: this.cudRecommendForm.accountId,
          region: this.cudRecommendForm.availableArea,
          cudType: this.cudRecommendForm.cudType,
          resourceType: this.cudRecommendForm.resourceType,
        })
        .then((res) => {
          this.averageQuantityOfUnmatchedCuds = res.data;
        });
    },
    /*********************下月推荐购买CUD后节省费用*********************/
    queryCostSaving: function () {
      this.$api.cudRecommend
        .queryCostSaving({
          accountId: this.cudRecommendForm.accountId,
          region: this.cudRecommendForm.availableArea,
          cudType: this.cudRecommendForm.cudType,
          resourceType: this.cudRecommendForm.resourceType,
        })
        .then((res) => {
          this.costSavingsAfterCudPurchase = res.data;
        });
    },

    /*************************CUD到期信息列表*************************/
    // CUD到期信息列表
    queryCUDExpireList: function () {
      this.$api.cudRecommend
        .queryCUDExpireList({
          accountId: this.cudRecommendForm.accountId,
          region: this.cudRecommendForm.region,
        })
        .then((res) => {
          this.tableDate = res.data;
        });
    },
    /******************柱状图********************************/
    // CUD使用情况
    checkCudStatistics: function () {
      this.$api.cudRecommend
        .checkCudStatistics({
          accountId: this.cudRecommendForm.accountId,
          region: this.cudRecommendForm.availableArea,
          cudType: this.cudRecommendForm.cudType,
          resourceType: this.cudRecommendForm.resourceType,
        })
        .then((res) => {
          this.init(res);
        });
    },
    init: function (res) {
      this.$nextTick(function () {
        this.cudUsageLine(res);
      });
    },
    cudUsageLine: function (res) {
      var a = res.data.onDemandQuantityData;
      var b = res.data.cudUsageData;
      var c = [];
      var len = b.length;
      for (var i = 0; i < len; i++) {
        c[i] = a[i] - b[i];
      }

      this.chartCudUsage = this.$echarts.init(
        document.getElementById("cudUsage")
      );
      this.chartCudUsage.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            var relVal = params[0].name;
            return (relVal +=
              "<br/>" +
              [
                params[0].marker +
                  params[0].seriesName +
                  " : " +
                  params[0].value,
                params[2].marker +
                  params[2].seriesName +
                  " : " +
                  params[2].value,
                params[3].marker +
                  params[3].seriesName +
                  " : " +
                  params[3].value,
              ].join("<br/>"));
          },
        },
        legend: {
          show: false,
          data: [{ name: "CUD使用量" }],
        },
        xAxis: {
          type: "category",
          data: res.data.xaxisData,
        },
        yAxis: {
          type: "value",
        },
        grid: {
          left: "1%",
          right: "1%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        series: [
          {
            name: "CUD匹配量",
            type: "bar",
            stack: "total",
            data: res.data.cudUsageData,
            barWidth: 25,
            itemStyle: {
              normal: { color: "#4282f4" },
            },
          },
          {
            name: "CUD剩余使用量",
            type: "bar",
            stack: "total",
            data: c,
            barWidth: 25,
            itemStyle: {
              normal: { color: "#9b999b" },
            },
          },
          {
            name: "按需数量",
            type: "bar",
            data: res.data.onDemandQuantityData,
            itemStyle: {
              normal: { color: "#ccc" },
            },
          },
          {
            name: "购买CUD数量",
            type: "line",
            symbol: "none",
            data: res.data.purchaseCudQuantityData,
            itemStyle: {
              normal: {
                color: "#3a3a3a",
                lineStyle: {
                  color: "#000",
                  type: "dotted", //'dotted'虚线 'solid'实线
                },
              },
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.cud-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}
.title {
  font-size: 13px;
  font-weight: 600;
  padding: 10px;
  float: left;
  color: #000;
}
a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/gcp/cud_recommendation_page/CudRecommendationPage.vue